import { useContext } from "react";
import { Layout, Dropdown, Avatar } from "antd";
import { useNavigate } from "react-router-dom";
import type { MenuProps } from "antd";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";

import { AuthContext } from "../../context/AuthContext";
import AdminIssueBadges from "./AdminIssueBadges";

import "../../styles/TopBar.css";

const { Header } = Layout;

const items: MenuProps["items"] = [
  {
    label: (
      <>
        <UserOutlined /> Profile
      </>
    ),
    key: "1",
  },
  {
    type: "divider",
  },
  {
    label: (
      <>
        <LogoutOutlined /> Logout
      </>
    ),
    key: "2",
  },
];

const AdminTopBar: React.FC = () => {
  const { adminLogout, currentUser } = useContext(AuthContext);

  const navigate = useNavigate();

  const onClick: MenuProps["onClick"] = ({ key }) => {
    switch (key) {
      case "1":
        navigate("#");
        break;
      case "2":
        adminLogout();
        break;
    }
  };

  return (
    <>
      <Header
        style={{ padding: "5px 16px", lineHeight: "normal" }}
        className="header"
      >
        <div className="logo"></div>
        <div
          className="avatar"
          style={{ display: "flex", alignItems: "center", gap: 16 }}
        >
          <AdminIssueBadges
            maintenanceEnabled={
              currentUser?.Role?.Name === "Super Admin"
            }
            maintenancePath="/admin/maintenance"
          />
          <Dropdown menu={{ items, onClick }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                cursor: "pointer",
              }}
            >
              <Avatar
                style={{ backgroundColor: "#f04f05" }}
                icon={<UserOutlined />}
              />
              <div className="user-meta">
                <p>
                  <strong>{currentUser ? currentUser.Name : ""}</strong>
                </p>
                <p style={{ fontSize: 12, color: "#8c8c8c" }}>
                  {currentUser ? currentUser.Role.Name : ""}
                </p>
              </div>
            </div>
          </Dropdown>
        </div>
      </Header>
    </>
  );
};

export default AdminTopBar;
